/* eslint-disable import/prefer-default-export */
import config from "@Config/index";

const BookEarlyItems = (t: (key: string) => string) => [
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/money-hand-image.svg`,
    subTitle: t("searchpage.components.bookearlyitems.lowerpricestitle"),
    content: t("searchpage.components.bookearlyitems.lowerpricesdescription"),
  },
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/early-bookings-location.svg`,
    subTitle: t("searchpage.components.bookearlyitems.primelocationstitle"),
    content: t("searchpage.components.bookearlyitems.primelocationsdescription"),
  },
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/early-booking-2x.svg`,
    subTitle: t("searchpage.components.bookearlyitems.twoxoptionstitle"),
    content: t("searchpage.components.bookearlyitems.twoxoptionsdescription"),
  },
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/early-booking-star.svg`,
    subTitle: t("searchpage.components.bookearlyitems.assuredstaystitle"),
    content: t("searchpage.components.bookearlyitems.assuredstaysdescription"),
  },
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/early-booking-calendar-new.svg`,
    subTitle: t("searchpage.components.bookearlyitems.riskproofbookingstitle"),
    content: t("searchpage.components.bookearlyitems.riskproofbookingsdescription"),
  },
];

const BookEarlyItemsV2 = (t: (key: string) => string) => [
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/LowerPrice.svg`,
    subTitle: t("searchpage.components.bookearlyitems.lowerpricestitle"),
    content: t("searchpage.components.bookearlyitems.lowerpricesdescription"),
  },
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/RiskProofBooking.svg`,
    subTitle: t("searchpage.components.bookearlyitems.riskproofbookingstitle"),
    content: t("searchpage.components.bookearlyitems.riskproofbookingsdescription"),
  },
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/PrimeLocation.svg`,
    subTitle: t("searchpage.components.bookearlyitems.primelocationstitle"),
    content: t("searchpage.components.bookearlyitems.primelocationsdescription"),
  },
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/BookOption.svg`,
    subTitle: t("searchpage.components.bookearlyitems.twoxoptionstitle"),
    content: t("searchpage.components.bookearlyitems.twoxoptionsdescription"),
  },
  {
    imgSrc: `${config.IMAGE_STATIC_URL}/images/AssuredStay.svg`,
    subTitle: t("searchpage.components.bookearlyitems.assuredstaystitle"),
    content: t("searchpage.components.bookearlyitems.assuredstaysdescription"),
  },
];

export { BookEarlyItems, BookEarlyItemsV2 };
